// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"141":"c6c9cb45b016d89f9467","576":"4ee10789dfed3364540a"}[chunkId] + ".bundle.js";
};